module.exports = __webpack_public_path__ + "media/bootstrap-icons/music-note-list-09c841e0.svg";